import * as angular from 'angular';

const runnerPublicSopModule = angular.module('flowingly.runner.publicsop', []);

runnerPublicSopModule.run([
  '$templateCache',
  function ($templateCache) {
    $templateCache.put(
      'Client/runner.publicsop/runner.publicsop.tmpl.html',
      require('./runner.publicsop.tmpl.html').default
    );
  }
]);
export default runnerPublicSopModule;
